"use strict";
import { createContext } from "solid-js";
export const RepoContext = createContext(
  null
);
//# sourceMappingURL=context.js.map
